import {
    allFetch
} from "../Domain";

/**
 * @description 車庫存
 */
export const CarWarehouse = (() => {
    /**
     * @description 新增新車庫存
     */
    const CarWarehouseCreate = async function (obj = {
        store_department: '',
        store_space: '',
        park_number_all: '',
        manage_user_id: '',
        manage_ul_id: '',
        custody_unit_id: ''
    }) {
        return await allFetch('CarWarehouse/CarWarehouseCreate', obj);
    }
    /**
     * 車倉庫查詢
     * @param {*} obj 
     * @returns 
     */
    const CarWarehouseSearch = async function (obj = {
        store_department: '',
        store_space: '',
        park_number_all: '',
        manage_user_id: '',
        manage_ul_id: '',
        custody_unit_id: '',
        cw_id: '',
        visible: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('CarWarehouse/CarWarehouseSearch', obj);
    }
    /**
     * 修改車倉庫
     * @param {*} obj 
     * @returns 
     */
    const CarWarehouseUpdate = async function (obj = {
        cw_id: '',
        store_department: '',
        store_space: '',
        park_number_all: '',
        manage_user_id: '',
        manage_ul_id: '',
        custody_unit_id: '',
        visible: ''
    }) {
        return await allFetch('CarWarehouse/CarWarehouseUpdate', obj);
    }
    return {
        CarWarehouseCreate,
        CarWarehouseSearch,
        CarWarehouseUpdate
    }
})();